import { GiPanda } from 'react-icons/gi'
import styles from './SuggestionComponent.module.scss'

const SuggestionComponent = ({ text }) => {
  return (
    <div className={styles.suggestionText}>
      <GiPanda size={18} className={styles.pandaImg} />
      {text}
    </div>
  )
}

export default SuggestionComponent
